import { css } from "styled-components";

const poppins_hero_base = css`
  font-family: var(--font-poppins);
  font-style: normal;
`;

export const poppins_hero_lg = css`
  ${poppins_hero_base};
  font-size: var(--text-hero-size-lg);
  line-height: 5.2rem;
  font-weight: 600;
  letter-spacing: -0.4px;
`;

export const poppins_hero_md = css`
  ${poppins_hero_base};
  font-size: var(--text-hero-size-md);
  line-height: 4.16rem;
  font-weight: 600;
  letter-spacing: -0.32px;
`;

export const poppins_hero_sm = css`
  ${poppins_hero_base};
  font-size: var(--text-hero-size-sm);
  line-height: 3.64rem;
  font-weight: 600;
  letter-spacing: -0.28px;
`;
